import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces, Trans } from 'react-i18next';
import { PaymentHistoryManager } from 'apps/payment/history/appManager';

import { Divider, SettingsSection } from 'legacyComponents/styled/lib';
import { Date } from 'apps/components/date';
import Spinner from 'components/Spinner';

import styled from 'styled-components';
import { SectionTitle } from 'apps/group/styles';
import { Table, THead, Th, Td } from 'apps/payment/styles';

@withNamespaces()
@inject('routerStore')
@observer
export class PaymentHistory extends React.Component {
  constructor(props) {
    super(props);
    const {
      routerStore: { params },
    } = props;
    const spaceSlug = params.get('spacePath');
    this.appManager = new PaymentHistoryManager(null, { spaceSlug });
  }

  render() {
    const { loading, paymentSpace } = this.appManager;
    if (loading || !paymentSpace) {
      return (
        <SettingsSection>
          <SectionTitle level={2} size='medium'>
            <Trans>Payment History</Trans>:
          </SectionTitle>
          <FullWidthDivider />
          <Spinner margin='20px auto' />
        </SettingsSection>
      );
    }

    const { invoices } = paymentSpace;
    const paymentLogBuilder = () => {
      if (!invoices || invoices.length === 0) {
        return (
          <p>
            <Trans>You have not made any payments yet.</Trans>
          </p>
        );
      }

      return (
        <Table>
          <THead>
            <tr>
              <Th />
              <Th>
                <Trans>Number</Trans>
              </Th>
              <Th>
                <Trans>Date</Trans>
              </Th>
              <Th>
                <Trans>Payment method</Trans>
              </Th>
              <Th>
                <Trans>Amount</Trans>
              </Th>
              <Th center>
                <Trans>Invoice</Trans>
              </Th>
            </tr>
          </THead>
          <tbody>
            {invoices.map(invoice => {
              const lastRow = invoices.indexOf(invoice) === invoices.length - 1;
              return (
                <tr key={invoice.number}>
                  <Td lastRow={lastRow} center>
                    {invoice.statusIcon}
                  </Td>
                  <Td lastRow={lastRow}>{invoice.number}</Td>
                  <Td lastRow={lastRow}>
                    <Date value={invoice.periodStart} noRelative />
                  </Td>
                  <Td lastRow={lastRow}>
                    {invoice.paymentMethod
                      ? `**** **** **** ${invoice.paymentMethod}`
                      : ''}
                  </Td>
                  <Td lastRow={lastRow}>{invoice.displayAmount}</Td>
                  {invoice.downloadUrl ? (
                    <Td lastRow={lastRow} center>
                      <a href={invoice.downloadUrl}>⬇️</a>
                    </Td>
                  ) : (
                    <Td lastRow={lastRow} center />
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
      );
    };
    const paymentLog = paymentLogBuilder();

    return (
      <SettingsSection>
        <SectionTitle level={2} size='medium'>
          <Trans>Payment History</Trans>:
        </SectionTitle>
        <FullWidthDivider />
        {paymentLog}
      </SettingsSection>
    );
  }
}

PaymentHistory.propTypes = {
  routerStore: PropTypes.object,
};

const FullWidthDivider = styled(Divider)`
  width: 100%;
  margin-bottom: 20px;
`;
